<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
      </app-form-save-button>
    </app-pageheader>
    <div class="columns is-justify-content-center">
      <div class="column is-8">
        <article class="panel">
          <p class="panel-heading">
            ParkChirp Configuration
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name">
              <div class="control">
                <input formControlName="Name" class="input" placeholder="Required" maxlength="40">
                <app-validator [For]="Form.get('Name')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Description">
              <div class="control">
                <textarea formControlName="Description" class="input" placeholder="Optional description" maxlength="200"></textarea>
                <app-validator [For]="Form.get('Description')"></app-validator>
              </div>
            </app-field>
            <app-field Label="API URL">
              <div class="control">
                <input formControlName="Url" class="input" placeholder="Required" maxlength="100">
                <app-validator [For]="Form.get('Url')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Username">
              <div class="control">
                <input formControlName="Username" class="input" placeholder="Required" maxlength="40">
                <app-validator [For]="Form.get('Username')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Password">
              <div class="control">
                <input formControlName="Password" type="password" class="input" [placeholder]="!this.ModelIsNew ? 'Password hidden for security - leave blank to keep existing password' : 'Required'" maxlength="40">
                <app-validator [For]="Form.get('Password')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Standard Initial Permit State">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="StandardInitialPermitState">
                    <option [ngValue]="null">Select initial state...</option>
                    @for (s of StandardWorkflowStates; track s) {
                      <option [ngValue]="s.Id">{{s.Name}}</option>
                    }
                  </select>
                </div>
                <app-validator [For]="Form.get('StandardInitialPermitState')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Standard Parking Permit Type">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="StandardParkingPermitTypeId">
                    <option value="">Select a permit type...</option>
                    @for (type of StandardParkingPermitTypes; track type) {
                      <option [value]="type.Id">{{type.Name}}</option>
                    }
                  </select>
                </div>
                <app-validator [For]="Form.get('StandardParkingPermitTypeId')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Reservation Initial Permit State">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="ReservationInitialPermitState">
                    <option [ngValue]="null">Select initial state...</option>
                    @for (s of ReservationWorkflowStates; track s) {
                      <option [ngValue]="s.Id">{{s.Name}}</option>
                    }
                  </select>
                </div>
                <app-validator [For]="Form.get('ReservationInitialPermitState')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Reservation Parking Permit Type">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="ReservationParkingPermitTypeId">
                    <option value="">Select a permit type...</option>
                    @for (type of ReservationParkingPermitTypes; track type) {
                      <option [value]="type.Id">{{type.Name}}</option>
                    }
                  </select>
                </div>
                <app-validator [For]="Form.get('ReservationParkingPermitTypeId')"></app-validator>
              </div>
            </app-field>
          </div>
        </article>
      </div>
    </div>
  </div>
}